import React from 'react';

function Contact() {
    return (
        <section data-image-src="img/background.png" className="contact-section section parallax-window" id="section-6">
            <div className="container">

                <div className="title">
                    <h3>Contact Us</h3>
                </div>

                <div className="col-lg-4 col-md-6 mb-4 contact-details">
                    <div className="tm-contact-item-inner-2">
                        <p>아리(Ahri)에게 하고 싶은 말이 있으신가요? &nbsp;
                            궁금한 점, 요청 사항, 제안하고 싶은 아이디어까지
                            언제든지 편하게 메시지 남겨 주세요! &nbsp;
                            빠른 시일 내에 답변드리겠습니다!
                        </p>
                        <ul className="font-weight-light">
                            <li>
                                <span className="icn"><i className="fas fa-mobile-alt"></i></span>
                                <span className="lbl">Tel:</span> <a href="#">02-521-1520</a>
                            </li>
                            <li>
                                <span className="icn"><i className="fas fa-at"></i></span>
                                <span className="lbl">Email:</span> <a href="#">bnsmd@bns.co.kr</a>
                            </li>
                            <li>
                                <span className="icn"><i className="fas fa-globe-asia"></i></span>
                                <span className="lbl">URL:</span> <a href="#">www.bns.co.kr</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Contact;
